import PropTypes from "prop-types";
import * as React from "react";
import { ClanName, Realm, TableBodyCell, TableRow } from "@wg/wows-react-uikit";
import { Tooltip, TooltipBody } from "components";

import { StatisticsValue } from "UIKit";

import { t } from "helpers/localization";

import { thousands } from "helpers/formatting";
import { isoToFormattedLocalDateTime } from "helpers/datetime";
import settings from "settings";
import styles from "./ClansRatingTable.scss";
import { SEASON_TYPES } from "../../../Reducers/ReducerRatings";

const propTypes = {
  rank: PropTypes.number.isRequired,
  league: PropTypes.number.isRequired,
  division: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  disbanded: PropTypes.bool.isRequired,
  clanId: PropTypes.number.isRequired,
  realm: PropTypes.string,
  isCrossRealmLadder: PropTypes.bool,
  tag: PropTypes.string.isRequired,
  tagColor: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  battlesCount: PropTypes.number.isRequired,
  lastBattle: PropTypes.string.isRequired,
  lastWin: PropTypes.string,
  membersCount: PropTypes.number.isRequired,
  isDisbanded: PropTypes.bool.isRequired,
  isOldSeason: PropTypes.bool,
  seasonType: PropTypes.string,

  onClick: PropTypes.func.isRequired
};

class ClansRatingTableItem extends React.PureComponent {


  onRowClick = () => {
    if (this.props.realm !== settings.realm.code) return;

    this.props.onClick(this.props.clanId);
  };

  renderMembersCount() {
    return this.props.isOldSeason || this.props.seasonType === SEASON_TYPES.BRAWL ? null : <TableBodyCell modify="right">
                    {this.props.membersCount}
                </TableBodyCell>;
  }
  renderWINS() {
    return this.props.seasonType === SEASON_TYPES.BRAWL ? <TableBodyCell modify="right">
                    {this.props.rating}
                </TableBodyCell> : null;
  }
  renderLBT() {
    return this.props.isOldSeason || this.props.seasonType === SEASON_TYPES.BRAWL ? null : <TableBodyCell modify="right">
                    {this.props.lastBattle ? isoToFormattedLocalDateTime(this.props.lastBattle) : '-'}
                </TableBodyCell>;
  }
  renderLWT() {
    return this.props.seasonType === SEASON_TYPES.BRAWL ? <TableBodyCell modify="right">
                    {this.props.lastWin ? isoToFormattedLocalDateTime(this.props.lastWin) : '-'}
                </TableBodyCell> : null;
  }
  renderDisbandedTooltip(tooltipId) {
    return <Tooltip id={tooltipId}>
                <TooltipBody>{t('Клан распущен')}</TooltipBody>
            </Tooltip>;
  }
  renderOtherRealmTooltipId(tooltipId) {
    return <Tooltip id={tooltipId}>
                <TooltipBody>{t('Невозможно открыть профиль клана находящегося не в вашем регионе')}</TooltipBody>
            </Tooltip>;
  }
  renderRealm() {
    return <TableBodyCell modify="compact">
                <Realm tooltipId={`item-clan-realm-tooltip-${this.props.clanId}`} realm={this.props.realm} realmMap={settings.realmsMap} />
            </TableBodyCell>;
  }

  renderBattlesCount() {
    return this.props.seasonType !== SEASON_TYPES.BRAWL ? <TableBodyCell modify="right">
                    <StatisticsValue value={thousands(this.props.battlesCount)} />
                </TableBodyCell> : null;
  }

  renderRating() {
    return this.props.seasonType !== SEASON_TYPES.BRAWL ? <TableBodyCell modify="right">
                    <StatisticsValue value={thousands(this.props.rating)} />
                </TableBodyCell> : null;
  }

  render() {
    const tooltipId = `item-clan-disbanded-tooltip-${this.props.clanId}`;
    const otherRealmTooltipId = this.props.realm !== settings.realm.code ? `item-clan-other-realm-tooltip-${this.props.clanId}` : null;

    return <div data-tip data-for={tooltipId}>
                <TableRow isHovering={!this.props.isDisbanded} isActive={this.props.isActive && !this.props.isDisbanded} isDisabled={this.props.isDisbanded} onClick={this.props.isDisbanded ? () => {} : this.onRowClick}>
                    <TableBodyCell modify="small">
                        <StatisticsValue className={styles[`rank-${this.props.rank}`]} value={thousands(this.props.rank)} />
                    </TableBodyCell>
                    {this.renderRealm()}
                    <TableBodyCell modify="basis">
                        <div data-tip data-for={otherRealmTooltipId} className={styles.clanNameWrap}>
                            <ClanName clanName={this.props.name} clanTag={this.props.tag} clanColor={this.props.tagColor} />
                            {otherRealmTooltipId && this.renderOtherRealmTooltipId(otherRealmTooltipId)}
                        </div>
                    </TableBodyCell>

                    {this.renderRating()}
                    {this.renderBattlesCount()}
                    {this.renderWINS()}
                    {this.renderLBT()}
                    {this.renderLWT()}
                    {this.renderMembersCount()}
                </TableRow>
                {this.props.isDisbanded && this.renderDisbandedTooltip(tooltipId)}
            </div>;
  }
}

ClansRatingTableItem.propTypes = propTypes;

export default ClansRatingTableItem;